// SkilledWorkers.jsx
import React from 'react';
import { Hammer, Award, Shield, Briefcase } from 'lucide-react';
import './SkilledWorkers.css';

const SkilledWorkers = ({ data, onChange, validationErrors = {} }) => {
  const handleMultiSelect = (field, value) => {
    const currentValues = data[field] || [];
    const newValues = currentValues.includes(value)
      ? currentValues.filter(v => v !== value)
      : [...currentValues, value];
    onChange(field, newValues);
  };

  const handleJobPositionChange = (index, value) => {
    const positions = data.skilledPositions || Array(7).fill('');
    positions[index] = value;
    onChange('skilledPositions', positions);
  };

  const handleOtherFieldChange = (field, value) => {
    onChange(field, value);
  };

  // Helper function to get error class
  const getErrorClass = (fieldName) => {
    return validationErrors[fieldName] ? 'error' : '';
  };

  // Helper function to render error message
  const renderError = (fieldName) => {
    if (validationErrors[fieldName]) {
      return (
        <div className="error-message" role="alert">
          {validationErrors[fieldName]}
        </div>
      );
    }
    return null;
  };

  return (
    <div className="step-content">
      <div className="step-header-section">
        {/* <Hammer className="section-icon" size={32} /> */}
        <h2>سادساً: وظائف العمالة الماهرة والبيانات الشخصية المطلوبة</h2>
      </div>
      
      {/* Skilled Workers Positions List */}
      <div className="">
        <div className="question-header">
          <span className="question-number">18</span>
          <label className="question-title">اذكر مسمى وظائف العمالة الماهرة الموجودة في شركتكم؟</label>
        </div>
        
        <div className="data-category">
          {/* <div className="category-header">
            <Hammer className="category-icon" size={24} />
            <h4>وظائف العمالة الماهرة:</h4>
          </div> */}
          
          <div className="positions-grid">
            {[0, 1, 2, 3, 4, 5, 6].map(index => (
              <div key={index} className="position-input-group skilled-position">
                <label className="position-label" htmlFor={`skilled-position-${index}`}>
                  المهنة {String(index + 1).padStart(2, '0')}:
                </label>
                <input
                  id={`skilled-position-${index}`}
                  type="text"
                  value={(data.skilledPositions || [])[index] || ''}
                  onChange={(e) => handleJobPositionChange(index, e.target.value)}
                  placeholder="(مثل: كهربائي، سباك، نجار، فني صيانة، طباخ...)"
                  className="position-input"
                />
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Personal Data Requirements */}
      <div className="">
        <div className="question-header">
          <span className="question-number">19</span>
          <label className="question-title">
            حدد البيانات الشخصية التي تطلبها شركتكم من المترشحين للتعيين على وظائف العمالة الماهرة؟ 
            <span className="required-indicator">*</span>
            <span className="multiple-choice-note">(يمكن اختيار أكثر من إجابة)</span>
          </label>
        </div>
        
        {/* All Requirements in One Category */}
        <div className="data-category" data-field="skilledWorkersData">
          <div className="category-header">
            <Award className="category-icon" size={24} />
            <h4>متطلبات العمالة الماهرة:</h4>
          </div>
          
          <div className={`skilled-requirements-grid ${getErrorClass('skilledWorkersData')}`}>
            {/* Qualifications & Licenses */}
            <div className="requirement-group">
              <h5 className="group-title">
                <Shield className="group-icon" size={18} />
                المؤهلات والتراخيص:
              </h5>
              {[
                'المؤهلات التخصصية',
                'رخصة مزاولة المهنة',
                'غير موجود'
              ].map(item => (
                <label key={item} className="checkbox-item skilled-qualification-item">
                  <input
                    type="checkbox"
                    checked={(data.skilledWorkersData || []).includes(item)}
                    onChange={() => handleMultiSelect('skilledWorkersData', item)}
                  />
                  <span className="checkbox-custom" aria-hidden="true"></span>
                  <span className="checkbox-text">{item}</span>
                </label>
              ))}
            </div>

            {/* Health & Safety */}
            <div className="requirement-group">
              <h5 className="group-title">
                <Shield className="group-icon" size={18} />
                الصحة والسلامة:
              </h5>
              {[
                'الحالة الصحية العامة',
                'التقرير الطبي الشامل',
                'القدرات الجسدية',
                'سجل الإصابات والأمراض المهنية',
                'متطلبات السلامة الخاصة',
                'غير موجود'
              ].map(item => (
                <label key={item} className="checkbox-item skilled-health-item">
                  <input
                    type="checkbox"
                    checked={(data.skilledWorkersData || []).includes(item)}
                    onChange={() => handleMultiSelect('skilledWorkersData', item)}
                  />
                  <span className="checkbox-custom" aria-hidden="true"></span>
                  <span className="checkbox-text">{item}</span>
                </label>
              ))}
            </div>

            {/* Work Experience */}
            <div className="requirement-group">
              <h5 className="group-title">
                <Briefcase className="group-icon" size={18} />
                الخبرة العملية:
              </h5>
              {[
                'بيانات الخبرة العملية',
                'أسماء الشركات أو المؤسسات السابقة',
                'طبيعة المهام والمسؤوليات السابقة',
                'تقييمات الأداء السابقة',
                'أسباب ترك الأعمال السابقة',
                'توصيات من أصحاب العمل السابقين',
                'غير موجود'
              ].map(item => (
                <label key={item} className="checkbox-item skilled-experience-item">
                  <input
                    type="checkbox"
                    checked={(data.skilledWorkersData || []).includes(item)}
                    onChange={() => handleMultiSelect('skilledWorkersData', item)}
                  />
                  <span className="checkbox-custom" aria-hidden="true"></span>
                  <span className="checkbox-text">{item}</span>
                </label>
              ))}
            </div>
          </div>
          {renderError('skilledWorkersData')}
          
          <div className="other-input-group">
            <label className="other-label" htmlFor="other-skilled-data">
              أخرى (يرجى ذكرها):
            </label>
            <input
              id="other-skilled-data"
              type="text"
              value={data.otherSkilledWorkersData || ''}
              onChange={(e) => handleOtherFieldChange('otherSkilledWorkersData', e.target.value)}
              placeholder="متطلبات أخرى للعمالة الماهرة..."
              className={`other-input ${getErrorClass('otherSkilledWorkersData')}`}
            />
            {renderError('otherSkilledWorkersData')}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SkilledWorkers;